export default __webpack_public_path__ + "static/media/FazendoMaisLogo.90a12d0c.png";